import { isScrolledIntoView } from "./helpers";
import select2 from "select2";

$(document).ready(function () {
  $(".js-select").each(function () {
    let $this = $(this);

    $this.select2({
      minimumInputLength: -1,
      dropdownParent: $this.parent(),
    });

    $this.on("change", function () {
      let url = $this.find(":selected").data("link") ?? "";
      console.log(url);
      if (url) {
        window.location.href = url;
      }
    });
  });

  $(".js-hover-previous").hover(
    function () {
      let $this = $(this);

      $this.prev().addClass("hovered");
      $this.addClass("hovered");
    },
    function () {
      let $this = $(this);

      $this.prev().removeClass("hovered");
      $this.removeClass("hovered");
    },
  );
});
